import * as React from 'react';
import {useCallback, useMemo, memo, useRef, useEffect, useState} from 'react';
import useJumpUrl from '@/hooks/useJumpUrl';
import {VALUE_TYPE} from '@/dicts/consts';
import {TopicModule} from '../../services/pages/channel/channel.client';
import styles from './index.less';
interface Props {
    page: string;
    sfRef?: string;
    channelBusinessLine?: string;
    infos: TopicModule;
}

// 需要大图宽度的样式类型
const NEED_BIG_WIDTH_TYPE = 19;

const SelfTopicImageHorizontal = ({infos, page, channelBusinessLine}: Props) => {
    // 逻辑：moduleMaxColumns 展示列数大于等于3时，展示3列图（含标题、副标题）
    // 展示列数=0、1、2、空时，展示2列图样式 （含标题、副标题）
    const moduleMaxColumns = infos.moduleMaxColumns ?? 0;

    const {navigateToUrl} = useJumpUrl();
    // 图片容器ref
    const imgModuleContainer = useRef<HTMLDivElement>(null);
    // 图片宽度
    const [imageWidth, setImageWidth] = useState(0);

    const handleClick = useCallback(
        (link?: string, swan?: string, itemId?: number, itemTitle?: string) => {
            const urlParams = {
                linkUrl: link,
                swanUrl: swan,
            };

            const logParams = {
                page: page,
                value: 'jump_tupian_henghuatu',
                channelId: infos?.channelId,
                pageType: channelBusinessLine,
                moduleId: itemId ?? infos?.moduleId,
                moduleName: infos?.moduleName,
                customize: {
                    // pm 要求打点字段格式为下划线连接
                    // eslint-disable-next-line camelcase
                    value_key: 'itemId',
                    // eslint-disable-next-line camelcase
                    value_type: VALUE_TYPE.ITEM,
                    // eslint-disable-next-line camelcase
                    value_id: itemId,
                    // eslint-disable-next-line camelcase
                    value_title: itemTitle,
                },
            };
            navigateToUrl(urlParams, logParams);
        },
        [
            page,
            infos.channelId,
            infos.moduleId,
            infos.moduleName,
            channelBusinessLine,
            navigateToUrl,
        ]
    );

    /**
     * 获取当前图片的宽度
     * 按照容器可视区域宽度的0.9比例
     */
    useEffect(
        () => {
            if (imgModuleContainer.current && infos?.moduleStyle === NEED_BIG_WIDTH_TYPE) {
                const containerWidth = imgModuleContainer.current.clientWidth;
                // 图片宽度为容器可视区域宽度的0.9 180为图片默认宽度
                const imgWidth = Math.ceil(containerWidth * 0.9) || 180;
                setImageWidth(imgWidth);
            }
        },
        [infos?.moduleStyle]
    );

    // 判断当前moduleStyle是不是为19，如果是 则修改img图片宽度
    const renderImgStyle = useMemo(
        () => {
            return {
                width: infos?.moduleStyle === NEED_BIG_WIDTH_TYPE ? `${imageWidth}px` : '180px',
                borderRadius: infos.moduleFillet === 1 ? '0' : '12px',
            };
        },
        [infos.moduleFillet, infos?.moduleStyle, imageWidth]
    );

    return (
        <div
            ref={imgModuleContainer}
            id={infos.moduleId?.toString()}
            data-show={JSON.stringify({
                'page': page,
                'value': 'jump_tupian_henghuatu',
                'pageSourceId': infos.channelId,
                'pageType': channelBusinessLine,
                'valueId': infos.moduleId,
                'valueTitle': infos.moduleName,
                'valueType': VALUE_TYPE.MODULE,
            })}
        >
            {
                (infos.isShowTitle === 1 && (infos.moduleName || infos.moduleSubTitle))
                    ? (
                        <div className={styles.titleParent}>
                            <div className={styles.titleContent}>
                                {
                                    infos.moduleName
                                        ? (
                                            <span className={styles.title}>
                                                {infos.moduleName}
                                            </span>
                                        )
                                        : null
                                }
                                {
                                    infos.moduleSubTitle
                                        ? (
                                            <span className={styles.subTitle}>
                                                {infos.moduleSubTitle}
                                            </span>
                                        )
                                        : null
                                }
                            </div>
                            <div>
                                {
                                    infos.moreUrl
                                        ? (
                                            <img
                                                src={'https://med-fe.cdn.bcebos.com/content-external-channel/rightDirect.png'}
                                                className={styles.rightMoreArrow}
                                                onClick={() => {
                                                    handleClick(infos.moreUrl);
                                                }}
                                            />
                                        )
                                        : null
                                }
                            </div>
                        </div>
                    )
                    : null
            }

            {
                moduleMaxColumns >= 3
                    ? (
                        <div className={styles.parent}>
                            {
                                infos.itemList?.map(
                                    // eslint-disable-next-line array-callback-return
                                    card => (
                                        <div
                                            id={card.itemId.toString()}
                                            key={card.itemId}
                                            className={styles.product}
                                            onClick={() => handleClick(
                                                card.fieldValue?.link,
                                                card.fieldValue?.swanUrl,
                                                card.itemId,
                                                card.title
                                            )}
                                            data-show={JSON.stringify({
                                                'page': page,
                                                'value': 'jump_tupian_henghuatu',
                                                'pageSourceId': infos.channelId,
                                                'pageType': channelBusinessLine,
                                                'valueId': card.itemId,
                                                'valueTitle': card.title,
                                                'valueType': VALUE_TYPE.ITEM,
                                            })}
                                        >
                                            <div
                                                className={styles.productBox}
                                                style={{
                                                    borderRadius: infos.moduleFillet === 1 ? '0' : '12px',
                                                }}
                                            >
                                                <img
                                                    className={styles.productImg}
                                                    src={card.fieldValue?.img}
                                                    style={{
                                                        borderRadius: infos.moduleFillet === 1 ? '0' : '12px',
                                                    }}
                                                />
                                            </div>
                                            {
                                                card.fieldValue?.title
                                                    ? (
                                                        <div className={styles.productName}>
                                                            {card.fieldValue?.title}
                                                        </div>
                                                    )
                                                    : null
                                            }
                                        </div>
                                    )
                                )
                            }
                        </div>
                    )
                    : (
                        <div className={styles.parent}>
                            {
                                infos.itemList?.map(
                                    card => (
                                        <div
                                            id={card.itemId.toString()}
                                            key={card.itemId}
                                            onClick={() => handleClick(
                                                card.fieldValue?.link,
                                                card.fieldValue?.swanUrl,
                                                card.itemId,
                                                card.title
                                            )}
                                            className={styles.card}
                                            data-show={JSON.stringify({
                                                'page': page,
                                                'value': 'jump_tupian_henghuatu',
                                                'pageSourceId': infos.channelId,
                                                'pageType': channelBusinessLine,
                                                'valueId': card.itemId,
                                                'valueTitle': card.title,
                                                'valueType': VALUE_TYPE.ITEM,
                                            })}
                                        >
                                            <img
                                                src={card.fieldValue?.img}
                                                className={styles.imgCard}
                                                style={renderImgStyle}
                                            />
                                            {
                                                card.fieldValue?.title
                                                    ? (
                                                        <div className={styles.cardTitle}>
                                                            {card.fieldValue?.title}
                                                        </div>
                                                    )
                                                    : null
                                            }
                                        </div>
                                    )
                                )
                            }
                        </div>
                    )
            }
        </div>
    );
};

export default memo(SelfTopicImageHorizontal);
